"use client";
import React, { useState, useCallback } from "react";
import useViewMore from "../../useViewMore";

import styles from "./Desc.mobile.module.scss";
import Skills from "./Skills.mobile";

export default function ViewMoreContent({ data, transData }) {
  // const [expand, setExpand] = useState(false);
  // const [showMore, setShowMore] = useState(false);
  const { showMore, expand, setExpand, viewMoreRef } = useViewMore(false);

  return (
    <div className={styles.viewMoreContent} ref={viewMoreRef}>
      {data.description_html ? (
        <div className={styles.richText}>
          <h4>{data.description_title}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: transData.isOriginal ? data.description_html : data.translationDescription
            }}
          />
        </div>
      ) : null}
      {data.requirement_html ? (
        <div className={styles.richText}>
          <h4>{data.requirement_title}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: transData.isOriginal ? data.requirement_html : data.translationRequirements
            }}
          />
        </div>
      ) : null}
      {Object.keys(data?.extraInfo ?? {}).some((el) => data?.extraInfo?.[el]) ? (
        <div className={styles.extraInfo}>
          {data?.extraInfo?.work_time ? (
            <div className={styles.row}>
              <span className={styles.label}>{data?.extraInfo?.work_time?.key}</span>
              <p>
                {/* {data?.extraInfo?.work_time?.value?.work_time_type_value ? (
                    <span style={{ marginBottom: 0 }}>
                      {data?.extraInfo?.work_time?.value?.work_time_type_value}
                    </span>
                  ) : null}
                  {data?.extraInfo?.work_time?.value?.work_time_range ? (
                    <span style={{ marginBottom: 0 }}>
                      {data?.extraInfo?.work_time?.value?.work_time_range}
                    </span>
                  ) : null}
                  {data?.extraInfo?.work_time?.value?.work_time_type_description ? (
                    <span style={{ marginBottom: 0 }}>
                      {data?.extraInfo?.work_time?.value?.work_time_type_description}
                    </span>
                  ) : null} */}
                {data?.extraInfo?.work_time?.work_time_text}
              </p>
            </div>
          ) : null}
          {data?.extraInfo?.holiday ? (
            <div className={styles.row}>
              <span className={styles.label}>{data?.extraInfo?.holiday?.key}</span>
              {/* <p>
                  {data?.extraInfo?.holiday?.value?.map((item, i) => (
                    <span key={i}>{item}</span>
                  ))}
                </p> */}
              <p>{data?.extraInfo?.holiday?.value_text}</p>
            </div>
          ) : null}
          {data?.extraInfo?.insurance ? (
            <div className={styles.row}>
              <span className={styles.label}>{data?.extraInfo?.insurance?.key}</span>
              {/* <p>
                  {data?.extraInfo?.insurance?.value?.map((item, i) => (
                    <span key={i}>{item}</span>
                  ))}
                </p> */}
              <p>{data?.extraInfo?.insurance?.value_text}</p>
            </div>
          ) : null}
          {data?.extraInfo?.contract ? (
            <div className={styles.row}>
              <span className={styles.label}>{data?.extraInfo?.contract?.key}</span>
              <p>{data?.extraInfo?.contract?.value}</p>
            </div>
          ) : null}
          {data?.extraInfo?.smoking ? (
            <div className={styles.row}>
              <span className={styles.label}>{data?.extraInfo?.smoking?.key}</span>
              <p>{data?.extraInfo?.smoking?.value}</p>
            </div>
          ) : null}
        </div>
      ) : null}
      <Skills data={transData.isOriginal ? data.skills : data.translationSkills} />
      {showMore ? (
        <div className={styles.viewMore} onClick={() => setExpand(true)}>
          {data.more_text}
        </div>
      ) : null}
    </div>
  );
}
